import { render, staticRenderFns } from "./PaymentUnavailableStatus.vue?vue&type=template&id=00827c84&scoped=true"
import script from "./PaymentUnavailableStatus.vue?vue&type=script&lang=js"
export * from "./PaymentUnavailableStatus.vue?vue&type=script&lang=js"
import style0 from "./PaymentUnavailableStatus.vue?vue&type=style&index=0&id=00827c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00827c84",
  null
  
)

export default component.exports